<template>
  <div class="">

    <Tabs type="card" v-model="current">
      <TabPane label="基础信息" name="projectBaseInfo">
        <keep-alive>
          <project-base-info :projectData="projectDetailInfoVo"></project-base-info>
        </keep-alive>
      </TabPane>
      <TabPane label="图片配置" name="picInfo">
        <keep-alive>
          <pic-info :list="topPicList" @showimg="showImg"></pic-info>
        </keep-alive>
      </TabPane>

      <TabPane label="公区配套设施" name="areaInfo">
        <keep-alive>
          <area-info :facilitiesData="facilitiesVosMore"></area-info>
        </keep-alive>
      </TabPane>
      <TabPane label="房型列表" name="houseTypeInfo">
        <keep-alive>
          <houseType-info :houseTypeData="houseTypeData"></houseType-info>
        </keep-alive>
      </TabPane>
      <TabPane label="周边及交通" name="ambitusInfo">
        <keep-alive>
          <ambitus-info :trafficList="projectDetailInfoVo.trafficList"></ambitus-info>
        </keep-alive>
      </TabPane>
      <TabPane label="您的ZO" name="zoInfo">
        <keep-alive>
          <zo-info :zoList="projectZoVos" @showimg="showImg"></zo-info>
        </keep-alive>
      </TabPane>
    </Tabs>
    <img-show :n="imgN" :src="imgSrc"></img-show>

  </div>
</template>

<script>
  import {getAllData} from "../../../api/project";
  import TableList from "components/TableList/index";
  import ImgShow from 'components/ImgShow/index';
  import ProjectBaseInfo from './components/ProjectBaseInfo';
  import PicInfo from './components/PicInfo';
  import AreaInfo from './components/AreaInfo';
  import AmbitusInfo from './components/AmbitusInfo';
  import ZoInfo from './components/ZoInfo';
  import HouseTypeInfo from './components/HouseTypeInfo';


  export default {
    components: {
      TableList,
      ImgShow,
      ProjectBaseInfo,
      PicInfo,
      AreaInfo,
      AmbitusInfo,
      ZoInfo,
      HouseTypeInfo
    },
    data() {
      return {
        projectFid: '',
        current: 'projectBaseInfo',
        imgN: 0,
        imgSrc: '',
        topPicList:[],
        facilitiesVosMore:[],
        projectDetailInfoVo:{},
        projectZoVos:[],
        houseTypeData:[]
      }
    },
    methods: {
      showImg(data) {
        this.imgSrc = data
        this.imgN++

      },
      getAllData(){
        if (!this.projectFid) {
          return
        }
        let params = {
          projectFid: this.projectFid
        }
        getAllData(params).then(res=>{
          if(!res.data || res.data.length===0){
            return
          }
          this.topPicList = res.data.projectDetailInfoVo.topPicList
          this.facilitiesVosMore = res.data.facilitiesVosMore
          this.projectDetailInfoVo = res.data.projectDetailInfoVo
          this.projectZoVos = res.data.projectZoVos.list ? res.data.projectZoVos.list : []
          this.houseTypeData = res.data.houseTypeInfoVos.list ? res.data.houseTypeInfoVos.list : []
        })
      }
    },
    computed: {},
    created() {
      this.projectFid = this.$route.query.projectFid
      this.getAllData()
      }
  }
</script>

<style scoped>

  .info-wrapper {
    display: flex;
  }

  .content {
    padding: 30px 20px;
    box-sizing: border-box;
  }
</style>
